export const COLORS = {
  select_gray: '#595959',
  picked_theme_stroke: '#007AFF',
  unpicked_theme_stroke: '#D9D9D9'
};
